import type { FaireProductEntity } from "../../entity_types/product";

export const p_69dbxvud2d: FaireProductEntity = {
  token: "p_69dbxvud2d",
  type: "product",
  name: "Boxed Greeting Cards - Happy Birthday",
  brandName: "Santa Barbara Design Studio by Creative Brands",
  imageUrl:
    "https://cdn.faire.com/fastly/1d05261c96589667b827bd56bcf7a8075fd1baaa9fe7e3481a903c4d6de18ad0.jpeg",
  priceDollars: 13.73,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/5c857d251b0ac0bb334fec74ee9a346f9bd473be22d63d27049d702fa558eedb.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
